
define('app/dashboard/account/views/accountPassView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	
	//Shims
	'jquery.sha256'
], function($, _, Backbone, UserModel){
	var Event = _.extend({}, Backbone.Events);

	var ChangePassFooterView = Backbone.View.extend({
		events: {
			'click #changePassFormSubmit': 'submitChangeForm'
		},
		
		initialize: function(options) {
			this.showForm();
			
			this.listenTo(Event, 'default', this.showForm);
			this.listenTo(Event, 'saving', this.showNonForm);
			this.listenTo(Event, 'error', this.showForm);
			this.listenTo(Event, 'success', this.showForm);
		},
		
		submitChangeForm: function () {
			Event.trigger("save");
		},
		
		showForm: function () {
			$(this.el).show();
		},
		
		showNonForm: function () {
			$(this.el).hide();
		},
	});

	var ChangePassContentView = Backbone.View.extend({	
		initialize: function(options) {
			this.hideAll();
			
			this.listenTo(Event, 'save', this.submitChange);
			this.listenTo(Event, 'default', this.defaultForm);
			this.listenTo(Event, 'saving', this.processing);
			this.listenTo(Event, 'error', this.form);
			this.listenTo(Event, 'success', this.success);
			
			//Error handling
			this.listenTo(Event, 'error:password', this.errorNewPassword);
			this.listenTo(Event, 'error:curPassword', this.errorCurPassword);
		},
		
		submitChange: function () {
			Event.trigger("saving");
			
			var newPassErr = false;
			var newPassErrCode = "";
			var curPassErr = false;
			var curpassErrCode = "";
			
			//Make sure the password has a length of 5 and isn't empty
			if(!this.$("#changePassNewPassInput").val()){
				newPassErr = true;
				newPassErrCode = "NULL";
			} else if(this.$("#changePassNewPassInput").val() && this.$("#changePassNewPassInput").val().length < 5){
				newPassErr = true;
				newPassErrCode = "LENGTH"; 
			}
			
			//Make sure current pass is supplied
			if(!this.$("#changePassCurPassInput").val()){
				curPassErr = true;
				curpassErrCode = "NULL";
			}
			
			if(!newPassErr && !curPassErr){
				this.model.save({
						password: this.$("#changePassNewPassInput").val() ? $.sha256(this.$("#changePassNewPassInput").val()) : "",
						curPassword: this.$("#changePassCurPassInput").val() ? $.sha256(this.$("#changePassCurPassInput").val()) : ""
					}, {
						wait: true,
						success : function(model, response){
							Event.trigger("savingSuccess", model, response);
						}, 
						error : function(model, error){
							Event.trigger("savingError", model, error);
						}
					});	
			} else {
				Event.trigger("error");
				
				if(newPassErr){
					Event.trigger("error:password", newPassErrCode);
				}
				
				if(curPassErr){
					Event.trigger("error:curPassword", curpassErrCode);
				}
			}
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			//Hide error messages
			this.$("#changePassCurPassInput").removeClass("error");
			this.$("#changePassNewPassInput").removeClass("error");
			this.$("#changePassCurPassErrMsg").hide();
			this.$("#changePassNewPassErrMsg").hide();
		},
		
		success: function () {
			this.hideAll();
			this.defaultForm();
		},
		
		processing: function () {
			this.hideAll();
		},
		
		defaultForm : function () {
			this.$("#changePassNewPassInput").val("");
			this.$("#changePassCurPassInput").val("");
			this.form();
		},
		
		form: function () {
			this.hideAll();
			$(this.el).show();
		},
		
		errorCurPassword : function (errorCode) {
			this.$("#changePassCurPassInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#changePassCurPassErrMsg").html("Current password is empty");
					this.$("#changePassCurPassErrMsg").show();
					break;
				case "NOTAUTH": 
					this.$("#changePassCurPassErrMsg").html("Password is incorrect, please enter the correct password");
					this.$("#changePassCurPassErrMsg").show();
					break;
				default : 
					this.$("#changePassCurPassErrMsg").html("Current password is invalid");
			}
		},
		
		errorNewPassword : function (errorCode) {
			this.$("#changePassNewPassInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#changePassNewPassErrMsg").html("New password is empty");
					this.$("#changePassNewPassErrMsg").show();
					break;
				case "LENGTH": 
					this.$("#changePassNewPassErrMsg").html("New password must be at least 5 characters long");
					this.$("#changePassNewPassErrMsg").show();
					break;
				default : 
					this.$("#changePassNewPassErrMsg").html("New password is invalid");
			}
		}
	});
	
	var ChangePassMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			this.listenTo(Event, 'default', this.hideAll);
			this.listenTo(Event, 'saving', this.processing);
			this.listenTo(Event, 'error', this.error);
			this.listenTo(Event, 'success', this.success);
		},
		
		hideAll: function() {
			$(this.el).hide();
			this.$("#changePassBodyMessageError").hide();
			this.$("#changePassBodyMessageProcessing").hide();
			this.$("#changePassBodyMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#changePassBodyMessageError").show();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#changePassBodyMessageSuccess").show();
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#changePassBodyMessageProcessing").show();
		},
	});
	
	var ChangePassView = Backbone.View.extend({
		el: $("#changePassContent"),
		
		initialize: function(options) {
			this.message = new ChangePassMessageView({el: this.$("#changePassBodyMessage"), model: this.model});
			this.content = new ChangePassContentView({el: this.$("#changePassBodyContent"), model: this.model});
			this.footer = new ChangePassFooterView({el: this.$("#changePassSubmitFooter"), model: this.model});
			
			this.listenTo(Event, 'savingSuccess', this.submitted);
			this.listenTo(Event, 'savingError', this.submitError);
			this.listenTo(Event, 'success', this.success);
			
			var passOpenBtn = $('#changePassOpen');
			
			passOpenBtn.on('click', {el: this.$("#changePassBodyContent")}, function (event) {
				event.data.el.collapse('toggle');
			});
			
			this.$("#changePassBodyContent").on('hide', {el: passOpenBtn}, function (event) {
				event.data.el.show();
			});
			
			this.$("#changePassBodyContent").on('show', {el: passOpenBtn}, function (event) {
				event.data.el.hide();
			});
		},
		
		render: function () {
			Event.trigger("default");
			return this;
		},
		
		submitError: function(model, error) {
			if (error.status == 400) {
				//Input errors
				Event.trigger("error");
				
				var errObj = JSON.parse(error.responseText);
				
				if(errObj.code){
					for(var i=0; i< errObj.code.length; i++){
						if(errObj.code[i].indexOf("_") > 0){
							//Trigger a specific event for the field with the code attached as a param
							var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
							var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
							Event.trigger("error:" + field.toLowerCase(), errCode);
						}
					}
				}
			} else if (error.status == 401) {
				//User already activated
				Event.trigger("error");
				Event.trigger("error:curPassword", "NOTAUTH");
			} else {
				Event.trigger("error");
			}
		},
		
		submitted: function () {
			this.model.clearPass();
			Event.trigger("success");
		},
		
		success: function () {
			this.$("#changePassBodyContent").collapse('hide');
		}
	});
	
	return ChangePassView;  
});